import { state } from 'cerebral'
import * as sequences from './sequences'
import apiClient from '../../lib/util/api-client'
import schemaSettings from '../../../shared/schemas/geofence-region-schema'
import { createProviders } from '../providers'
import { redirectUnauthorized, createCrudState } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'
import { boundsForMap, geofencesForMap } from './computed'

const { geofenceRegionSchema: schema } = schemaSettings
const service = apiClient.service('geofence-regions')

export default ({ name }) => ({
  state: {
    ...createCrudState({
      entityType: 'geofenceRegions',
      storePrefix: name,
    }),
    shownOnMap: {},
    geofencesForMap,
    boundsForMap,
  },
  sequences,
  providers: createProviders({ name, service, schema }),
  catch: [
    redirectUnauthorized(),
    [
      Error,
      showFeedbackFromError({ title: 'We encountered an error' }),
      ({ props: { error, errorPath = name }, store }) => {
        store.set(state`errors.${errorPath}`, error)
      },
    ],
  ],
})
